import React, { FC } from 'react';
import COButton from 'shared/components/COButton';
import { OrganizationMapReset } from '.';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import styles from './organisationMapReactFlow.module.scss';

export const ZoomControls: FC<{
    mapRef: React.RefObject<OrganizationMapReset>;
}> = ({ mapRef }) => {
    const zoomIn = () => {
        if (mapRef.current) {
            mapRef.current.zoomIn();
        }
    };

    const zoomOut = () => {
        if (mapRef.current) {
            mapRef.current.zoomOut();
        }
    };

    const handleZoomInFocus = () => {
        // Handle focus event if needed
    };

    const handleZoomOutFocus = () => {
        // Handle focus event if needed
    };

    return (
        <div className={styles.zoomControls}>
            <div className={styles.zoomButtonsContainer}>
                <button
                    className={styles.zoomInButton}
                    onClick={zoomIn}
                    onFocus={handleZoomInFocus}
                    aria-label="Zoom in"
                    type="button">
                    <PlusOutlined />
                </button>
                <div className={styles.zoomDivider}></div>
                <button
                    className={styles.zoomOutButton}
                    onClick={zoomOut}
                    onFocus={handleZoomOutFocus}
                    aria-label="Zoom out"
                    type="button">
                    <MinusOutlined />
                </button>
            </div>
        </div>
    );
};

